export interface TokenEndpointResponse {
    url: string;
    status: number;
    statusText: string;
    responseText: string;
    parsedBody: Record<string, unknown> | null;
    requestTimestamp: number;
    responseTimestamp: number;
    durationMs: number;
}

let lastResponse: TokenEndpointResponse | null = null;
let installed = false;

const isTokenEndpoint = (url: string) =>
    typeof url === 'string' && url.includes('/protocol/openid-connect/token');

const safeParse = (text: string): Record<string, unknown> | null => {
    try {
        return JSON.parse(text);
    } catch {
        return null;
    }
};

export const installTokenEndpointMonitor = () => {
    if (installed) return;
    installed = true;

    const OriginalOpen = XMLHttpRequest.prototype.open;
    const OriginalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (
        this: XMLHttpRequest & { __keycloakUrl?: string; __keycloakStart?: number },
        method: string,
        url: string | URL,
        ...rest: unknown[]
    ) {
        const urlString = typeof url === 'string' ? url : url.toString();
        if (isTokenEndpoint(urlString)) {
            this.__keycloakUrl = urlString;
        }
        // @ts-expect-error — forwarding rest args to original impl
        return OriginalOpen.apply(this, [method, url, ...rest]);
    };

    XMLHttpRequest.prototype.send = function (
        this: XMLHttpRequest & { __keycloakUrl?: string; __keycloakStart?: number },
        ...args: unknown[]
    ) {
        if (this.__keycloakUrl) {
            const requestTimestamp = Date.now();
            this.__keycloakStart = requestTimestamp;

            this.addEventListener('loadend', () => {
                const responseTimestamp = Date.now();
                const responseText = (() => {
                    try {
                        return this.responseType === '' || this.responseType === 'text'
                            ? this.responseText ?? ''
                            : '';
                    } catch {
                        return '';
                    }
                })();

                lastResponse = {
                    url: this.__keycloakUrl!,
                    status: this.status,
                    statusText: this.statusText,
                    responseText: responseText.slice(0, 2000),
                    parsedBody: safeParse(responseText),
                    requestTimestamp,
                    responseTimestamp,
                    durationMs: responseTimestamp - requestTimestamp,
                };
            });
        }
        // @ts-expect-error — forwarding args to original impl
        return OriginalSend.apply(this, args);
    };
};

export const getLastTokenResponse = (): TokenEndpointResponse | null => lastResponse;

export const getLastTokenResponseForSentry = () => {
    const r = lastResponse;
    if (!r) return { lastTokenResponse: null };

    const ageMs = Date.now() - r.responseTimestamp;
    return {
        lastTokenResponse: {
            status: r.status,
            statusText: r.statusText,
            durationMs: r.durationMs,
            ageMs,
            error: r.parsedBody?.error ?? null,
            errorDescription: r.parsedBody?.error_description ?? null,
            responseText: r.responseText,
        },
    };
};
